import { __decorate, __metadata } from "tslib";
import { appendClass, dispatchEvent, subscribe } from '@1inch-community/core/lit-utils';
import { BigFloat } from '@1inch-community/core/math';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { fromEvent, tap } from 'rxjs';
import { bigFloatInputStyle } from './big-float-input.style';
let BigFloatInputElement = class BigFloatInputElement extends LitElement {
    constructor() {
        super(...arguments);
        this.decimals = 6;
        this.disabled = false;
        this._value = BigFloat.zero();
        this.input = document.createElement('input');
    }
    static { this.tagName = 'inch-big-float-input'; }
    static { this.styles = bigFloatInputStyle; }
    set value(value) {
        if (!(value instanceof BigFloat)) {
            return;
        }
        if (!this._value.equals(value)) {
            this._value = value;
            this.input.value = value.toFixedSmart(this.decimals);
        }
    }
    get value() {
        return this._value;
    }
    firstUpdated() {
        appendClass(this.input, {
            input: true,
        });
        if (this.disabled) {
            this.input.setAttribute('disabled', '');
        }
        this.input.setAttribute('inputmode', 'decimal');
        this.input.setAttribute('autocomplete', 'off');
        this.input.setAttribute('placeholder', '0');
        subscribe(this, [
            fromEvent(this.input, 'keypress').pipe(tap((event) => this.keypressHandler(event))),
            fromEvent(this.input, 'input').pipe(tap(() => this.inputHandler())),
        ], { requestUpdate: false });
    }
    render() {
        return html `${this.input}`;
    }
    keypressHandler(event) {
        const char = event.key;
        if (char === '.' && this.input.value.length > 0) {
            if (this.input.value.includes('.')) {
                event.preventDefault();
            }
            return;
        }
        if (char.length === 1 && !char.match(/[0-9]/)) {
            event.preventDefault();
        }
    }
    inputHandler() {
        let value = this.input.value;
        if (value === '') {
            dispatchEvent(this, 'change', BigFloat.zero());
            return;
        }
        let dotOnEnd = false;
        if (value[value.length - 1] === '.') {
            value = value.slice(0, value.length - 1);
            dotOnEnd = true;
        }
        value = value.replace(/\s+/g, '');
        value = value.replace(/[^0-9.]/g, '');
        const bigFloat = BigFloat.fromString(value);
        let formatedString = bigFloat.toFixedSmart(this.decimals);
        if (dotOnEnd) {
            formatedString += '.';
        }
        this.input.value = formatedString;
        if (!this.value.equals(bigFloat)) {
            this._value = bigFloat;
            dispatchEvent(this, 'change', this.value);
        }
    }
};
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], BigFloatInputElement.prototype, "value", null);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Number)
], BigFloatInputElement.prototype, "decimals", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], BigFloatInputElement.prototype, "disabled", void 0);
BigFloatInputElement = __decorate([
    customElement(BigFloatInputElement.tagName)
], BigFloatInputElement);
export { BigFloatInputElement };
//# sourceMappingURL=big-float-input.element.js.map